import axios from 'axios';

class API {

  async configure() {
    const api = axios.create({
      baseURL: `${process.env.VUE_APP_API_BASE_REST_ALERT}`,
      timeout: 60000
    });
    return api;
  }
}

export default API;